import React from 'react';

const NotFound = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif'
    }}>
        <h1 style={{ fontSize: '4rem', margin: 0 }}>404</h1>
        <p style={{ fontSize: '1.5rem', margin: '1rem 0' }}>Page Not Found</p>
        <a  style={{
            color: '#1976d2',
            textDecoration: 'none',
            fontSize: '1rem',
            marginTop: '1rem'
        }}>
            Go to Home
        </a>
    </div>
);

export default NotFound;